var React = require('react');

function Sound (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.33203 3.83331L3.9987 6.49998H1.33203V10.5H3.9987L7.33203 13.1666V3.83331Z","stroke":"#333333","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.3594 6.14001C10.9843 6.76511 11.3353 7.6128 11.3353 8.49668C11.3353 9.38056 10.9843 10.2283 10.3594 10.8533","stroke":"#333333","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12.7148 3.78668C13.9647 5.03687 14.6668 6.73225 14.6668 8.50002C14.6668 10.2678 13.9647 11.9632 12.7148 13.2133","stroke":"#333333","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Sound.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Sound;

Sound.default = Sound;
